module.exports = __webpack_public_path__ + "static/media/walking.ca9b296e.jpg";